__webpack_require__.p = "/pricetag/";